// Generated by ReScript, PLEASE EDIT WITH CARE

import ThemeProvider from "./ThemeProvider";

var make = ThemeProvider;

export {
  make ,
  
}
/* make Not a pure module */
